// import { firestoreId } from '../../../globalVars/data';
import { doc, Timestamp, updateDoc } from 'firebase/firestore';
import { getCtData } from '../../project';
import { firestoreOutFlax } from './firebase';
import { sanitizeForFirebase } from './utils';

export const css1 =
  'color: #ffb73b; background-color: black; font-size: 11px; padding: 2px 6px; border-radius: 3px';
export const css2 =
  'color: black; background-color: #ffb73b; font-size: 10px; padding: 2px 6px; border-radius: 3px';

type Tprops = {
  args: any;
  pass: {
    fbInit?: any[];
    arrRefStrings: string[];
    arrPathData: string[];
    arrFuncs: any[];
  };
};

export const updateDocTool = async (props: Tprops) => {
  // ---------- set Props
  const { args, pass } = props;
  const { arrRefStrings, arrPathData, arrFuncs } = pass;

  // ---------- set Local Imports
  // const { getFirestore, doc, updateDoc, Timestamp } = await import(
  //   '@firebase/firestore'
  // );

  // ---------- set Caps Inputs
  // let fbInit = [!#!firestore init path!#!];
  // let newArrRef = [!#!array firestore reference!#!];
  // const arrayData = [!#!data to set!#!];
  // const arrFuncs = [!#!functions return!#!];

  // -----------------------------
  // ---------- set Firestore Call
  // -----------------------------
  // console.log({ fbInit });
  // console.log(fbInit[0]);
  console.log({ arrRefStrings });
  const refColl = doc(firestoreOutFlax, ...arrRefStrings);
  //   const refDoc = doc(refColl);

  // ------ check Data
  if (!Array.isArray(arrRefStrings))
    return console.log(
      'arrRefStrings needs to be a string array',
      arrRefStrings,
    );

  // ------ read Data
  let dataToUpdate: any = {};
  console.log({ arrPathData });
  dataToUpdate = getCtData(arrPathData.join());
  console.log({ dataToUpdate });

  // ------ add date update
  dataToUpdate.updatedAt = Timestamp.now();

  const sanitizedData = sanitizeForFirebase(dataToUpdate);

  await updateDoc(refColl, sanitizedData).catch(err =>
    console.log('Erro do updateDoc', { err }),
  );

  // ---------- set Get Value Functions
  for (const currFunc of arrFuncs) await currFunc(sanitizedData, args);

  console.log('%cupdateDoc ok', css1);
  console.log('%cReferencia do Documento', css2, {
    arrRefStrings,
    sanitizedData,
  });

  return sanitizedData;
};
// sc.A11.currData.itemID
// sc.A11.forms.editData
